import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { site } from "@/content";
import { useLang } from "@/lang";
import { EASE } from "@/components/Reveal";

const labels = {
    it: [
        { label: "Chi sono", href: "#chi-sono", id: "nav-link-chi-sono" },
        { label: "Esperienza", href: "#esperienza", id: "nav-link-esperienza" },
        { label: "Contatti", href: "#contatti", id: "nav-link-contatti" },
        { label: "Privacy", href: "#privacy", id: "nav-link-privacy" },
    ],
    en: [
        { label: "About", href: "#chi-sono", id: "nav-link-chi-sono" },
        { label: "Experience", href: "#esperienza", id: "nav-link-esperienza" },
        { label: "Contact", href: "#contatti", id: "nav-link-contatti" },
        { label: "Privacy", href: "#privacy", id: "nav-link-privacy" },
    ],
};

const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -60, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export default function Nav() {
    const { lang, setLang } = useLang();
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const t = setInterval(() => setNow(new Date()), 15000);
        return () => clearInterval(t);
    }, []);

    const dateStr = now.toLocaleDateString(lang === "en" ? "en-GB" : "it-IT", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
    const timeStr = now.toLocaleTimeString("it-IT", {
        hour: "2-digit",
        minute: "2-digit",
    });

    return (
        <motion.header
            data-testid="main-nav"
            className="fixed inset-x-0 top-0 z-40 border-b-2 border-ink bg-paper"
            initial={{ y: -60 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.8, delay: 0.15, ease: EASE }}
        >
            <div className="mx-auto flex h-12 max-w-[1400px] items-center gap-4 px-3 md:px-6">
                <a
                    href="#top"
                    onClick={(e) => go(e, "#top")}
                    data-testid="nav-logo"
                    className="flex items-center gap-2 px-1.5 py-1 text-xs font-extrabold uppercase tracking-[0.12em] transition-colors duration-150 hover:bg-ink hover:text-paper"
                >
                    <span
                        data-testid="nav-logo-fg"
                        className="flex h-9 w-9 flex-col items-center justify-center border-2 border-ink bg-[#A8C800] shadow-[2px_2px_0_#000]"
                    >
                        <span className="font-display text-[15px] font-black italic leading-none tracking-[-0.06em] text-ink">
                            FG
                        </span>
                        <span
                            className="mt-[3px] flex h-[6px] w-6 border border-ink/20"
                            aria-hidden="true"
                            title="Italia"
                        >
                            <span className="flex-1 bg-[#009246]" />
                            <span className="flex-1 bg-white" />
                            <span className="flex-1 bg-[#CE2B37]" />
                        </span>
                    </span>
                    <span className="hidden sm:inline">{site.name}</span>
                </a>
                <nav className="hidden items-center gap-1 md:flex">
                    {labels[lang].map((l) => (
                        <a
                            key={l.id}
                            href={l.href}
                            onClick={(e) => go(e, l.href)}
                            data-testid={l.id}
                            className="px-2 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] transition-colors duration-150 hover:bg-ink hover:text-paper"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="ml-auto flex items-center gap-3 md:gap-4">
                    <span
                        data-testid="menu-clock"
                        className="hidden text-xs font-semibold tracking-wider sm:block"
                    >
                        {dateStr} · {timeStr}
                    </span>
                    <div className="flex border-2 border-ink" data-testid="lang-toggle">
                        {["it", "en"].map((l) => (
                            <button
                                key={l}
                                type="button"
                                data-testid={`lang-toggle-${l}`}
                                onClick={() => setLang(l)}
                                className={`px-2 py-1 text-[11px] font-extrabold uppercase tracking-wider transition-colors duration-150 ${
                                    lang === l
                                        ? "bg-ink text-paper"
                                        : "hover:bg-ink hover:text-paper"
                                }`}
                            >
                                {l}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </motion.header>
    );
}
